module.exports = __webpack_public_path__ + "static/media/export.0b5bc504.svg";